import _ from 'lodash'

export default {
  namespaced: true,
  state: {
    livingOptions: [],
    subsections: [],
    properties: [],
    propertyModels: [],

    inputType: null,
    inputBeds: false,
    inputBaths: false,
    inputCars: false,
    inputView: false,
  },

  mutations: {
    SET_LIVING_OPTIONS (state, livingOptions) {
      state.livingOptions = livingOptions
    },

    SET_SUBSECTIONS (state, subsections) {
      state.subsections = subsections
    },

    SET_PROPERTIES (state, properties) {
      state.properties = properties
    },

    SET_PROPERTY_MODELS (state, propertyModels) {
      state.propertyModels = propertyModels
    },    

    SET_FILTER_PARAMETERS: (state, parameters) => {
      if (!_.isUndefined(parameters.inputType)) state.inputType = parameters.inputType
      if (!_.isUndefined(parameters.inputBeds)) state.inputBeds = parameters.inputBeds
      if (!_.isUndefined(parameters.inputBaths)) state.inputBaths = parameters.inputBaths
      if (!_.isUndefined(parameters.inputCars)) state.inputCars = parameters.inputCars
      if (!_.isUndefined(parameters.inputView)) state.inputView = parameters.inputView
    },    

    RESET_FILTER_PARAMETERS: state => {
      state.inputType = null
      state.inputBeds = false
      state.inputBaths = false
      state.inputCars = false
      state.inputView = false
    },
  },

  getters: {
    activeLivingOption: (state, getters, rootState) => {
      if (rootState.route.params.livingOptionId) {
        const livingOption = _.find(getters.livingOptions, livingOption => {
          return livingOption._id === rootState.route.params.livingOptionId
        })

        return livingOption
      } else {
        return null
      }
    },

    activeModel: (state, getters) => {
      if (getters.activeProperty) {
        return _.find(state.propertyModels, model => {
          return model._id === getters.activeProperty.modelId
        })
      } else {
        return null
      }
    },

    activeProperty: (state, getters, rootState) => {
      if (rootState.route.params.propertyId) {
        return _.find(getters.properties, property => {
          return property._id === rootState.route.params.propertyId
        })
      } else {
        return null
      }
    },

    activeSubsection: (state, getters, rootState) => {
      if (getters.activeLivingOption && rootState.route.params.subsectionId) {
        return _.find(getters.subsections, subsection => {
          return subsection._id === rootState.route.params.subsectionId
        })
      } else {
        return null
      }
    },

    livingOptions: (state, getters) => {
      if (getters.subsections.length && getters.properties.length) {
        let livingOptions = JSON.parse(JSON.stringify(state.livingOptions))

        // filter out if isEnabled true
        livingOptions = _.filter(livingOptions, livingOption => { return livingOption.isEnabled })
        
        livingOptions.forEach(livingOption => {
          let bedFiltering = []
          let homeTypeFiltering = []
          let viewFiltering = []

          // Add propertyTypes and properties TODO: Move server side
          let propertyTypes = []
          let propertyIds = []
          let properties = []
          
          livingOption.subsectionIds.forEach(subsectionId => {
            const subsection = _.find(getters.subsections, subsection => {
              return subsection._id === subsectionId
            })
            if (subsection) {
              if (subsection.subsectionIds.length) {
                subsection.subsectionIds.forEach(_subsectionId => {
                  const _subsection = _.find(getters.subsections, _subsection => {
                    return _subsection._id === _subsectionId
                  })
                  propertyIds.push(..._subsection.propertyIds)
                })
              }
              propertyIds.push(...subsection.propertyIds)
            }
          })
          livingOption.propertyIds = propertyIds
          if (livingOption.propertyIds) {
            livingOption.propertyIds.forEach(propertyId => {
              const property = _.find(getters.properties, property => { return property._id === propertyId })
              if (property && property.models[0]) {
                bedFiltering.push(parseInt(property.models[0].beds > 4 ? 4 : property.models[0].beds))
                homeTypeFiltering.push(property.models[0].type)
                viewFiltering.push(property.view)
                
                properties.push(property)
                property.models.forEach(model => {
                  propertyTypes.push(model.type)
                })
              } 
            })
          }
          livingOption.propertyTypes = _.uniq(propertyTypes)
          livingOption.properties = properties

          // *** hide property filtering ***
          livingOption.filter = false
          // livingOption.properties.forEach(property => {
          //   if (property.filter === false) {
          //     livingOption.filter = false
          //   }
          // })
          let subsections = []
          livingOption.subsectionIds.forEach(subsectionId => { 
            subsections.push(_.find(getters.subsections, subsection => {
              return subsection._id === subsectionId
            }))
          })
          livingOption.subsections = subsections


          // check filtering status for living optiond that only contain subsections and no properties
          if (livingOption.subsections && !livingOption.properties.length) {
            let filter = true

            livingOption.subsections.forEach(subsection => {
              if (!subsection.filter) {
                filter = false
              }
            })

            livingOption.filter = filter
          }

          // ok ok, build filtering ranges for each filtering type
          livingOption.filtering = {
            beds: _.uniq(bedFiltering),
            homeType: _.uniq(homeTypeFiltering),
            view: _.uniq(viewFiltering),
          }
        })
        return livingOptions
      } else {
        return []
      }
    },

    livingOptionsWithFiltering: (state, getters) => {
      if (getters.livingOptions.length) {
        let livingOptions = JSON.parse(JSON.stringify(getters.livingOptions))

        livingOptions.forEach(livingOption => {
          // livingOption.filter = false

          if (state.inputBeds || state.inputBeds === 0) {
            if (!livingOption.filtering.beds.includes(state.inputBeds)) {
              livingOption.filter = true
            }
          }

          if (state.inputType) {
            if (!livingOption.filtering.homeType.includes(state.inputType)) {
              livingOption.filter = true
            }
          }

          if (state.inputView) {
            if (!livingOption.filtering.view.includes(state.inputView)) {
              livingOption.filter = true
            }
          }
        })
        return livingOptions
      } else {
        return []
      }
    },

    // Adds some attributes to the raw list of properies, specifically: assigns the model object and filtered state
    properties: state => {
      if (state.propertyModels.length) {
        let properties = JSON.parse(JSON.stringify(state.properties))

        properties.forEach(property => {
          // Push the associated property models into property.models
          property.models = _.filter(state.propertyModels, model => {
            return property.modelIds.includes(model._id)
          })

          if (property.models.length) {
            property.filter =  false

            // property.models.forEach(model => {
            //   // const beds = parseInt(model.beds) > 4 ? 4 : parseInt(model.beds)
            //   const baths = model.baths > 4 ? 4 : model.baths
            //   const cars = model.cars > 4 ? 4 : model.cars   

            //   if (state.inputType && state.inputType !== model.type) {
            //     property.filter =  true

            //   } else if (state.inputBaths && state.inputBaths !== baths) {
            //     // No bathroom data
            //     property.filter =  true
              
            //   } else if ((state.inputBeds || state.inputBeds === 0) && state.inputBeds !== beds) {
            //     property.filter =  true

            //   } else if (state.inputCars && state.inputCars !== cars) {
            //     // No car data
            //     property.filter =  true
            //   }
            // })
          }

          // filter on the property object
          //  const view = property.view 
          //  if (state.inputView && state.inputView !== view) {
          //    property.filter = true
          //  }
        })
        return properties
      } else {
        return []
      }
    },

    propertiesFiltered: (state, getters) => {
      if (getters.activeSubsection) {
        let properties = getters.activeSubsection.properties

        properties.forEach(property => {
          // Push the associated property models into property.models
          property.models = _.filter(state.propertyModels, model => {
            return property.modelIds.includes(model._id)
          })

          if (property.models.length) {
            property.filter =  false

            property.models.forEach(model => {
              const beds = parseInt(model.beds) > 4 ? 4 : parseInt(model.beds)
              const baths = model.baths > 4 ? 4 : model.baths
              const cars = model.cars > 4 ? 4 : model.cars   

              if (state.inputType && state.inputType !== model.type) {
                property.filter =  true

              } else if (state.inputBaths && state.inputBaths !== baths) {
                // No bathroom data
                property.filter =  true
              
              } else if ((state.inputBeds || state.inputBeds === 0) && state.inputBeds !== beds) {
                property.filter =  true

              } else if (state.inputCars && state.inputCars !== cars) {
                // No car data
                property.filter =  true
              }
            })
          }

          // filter on the property object
           const view = property.view 
           if (state.inputView && state.inputView !== view) {
             property.filter = true
           }
        })
        return properties
      } else {
        return []
      }
    },

    propertyTypes: state => {
      let types = []
      state.propertyModels.forEach(propertyModel => {
        types.push(propertyModel.type.toLowerCase())
      })
      return _.uniq(types)
    },

    propertyViews: state => {
      let views = []
      state.properties.forEach(property => {
        if (property.status === 'Available' || property.status === 'Blocked') {
          views.push(property.view)
        }
      })
      return _.uniq(views)
    },

    // Returns an array of Subsection objects with their associated Properties nested inside
    // Also sets a "filter" flag to true if all properties have been filtered out
    // Also handles nested subsections
    subsections: (state, getters) => {
      if (getters.properties.length) {
      // Clone subsections from state
        let subsections = JSON.parse(JSON.stringify(state.subsections))

        // Next associated properties
        subsections.forEach(subsection => {
          let bedFiltering = []
          let homeTypeFiltering = []
          let viewFiltering = []
          let propertyCountFiltering = 0

          let properties = []

          subsection.propertyIds.forEach(propertyId => {
            const property = _.find(getters.properties, property => { return property._id === propertyId })

            if (property && property.models[0]) {
              bedFiltering.push(parseInt(property.models[0].beds > 4 ? 4 : property.models[0].beds))
              homeTypeFiltering.push(property.models[0].type)
              viewFiltering.push(property.view)

              properties.push(property)
            }
          })
          subsection.properties = properties

          if (subsection.subsectionIds && subsection.subsectionIds.length) {
            subsection.subsections = []
            subsection.subsectionIds.forEach(subsectionId => {
              const subSubsection = _.find(subsections, subsection => { return subsection._id === subsectionId })
              subsection.subsections.push(subSubsection)
            })
          }

          if (subsection.allPropertyIds) {
            subsection.allProperties = []
            subsection.allPropertyIds.forEach(propertyId => {
              const property = _.find(getters.properties, property => { return property._id === propertyId })
              if (property) {
                subsection.allProperties.push(property)
              } 
            })
          }     

          let filter = true
          subsection.propertyIds.forEach(propertyId => {
            const property = getters.properties.find(property => property._id === propertyId)
            if (property && !property.filter) {
              filter = false
              propertyCountFiltering++
            }
          })
          subsection.filter = filter

          subsection.filtering = {
            beds: _.uniq(bedFiltering),
            homeType: _.uniq(homeTypeFiltering),
            view: _.uniq(viewFiltering),
            propertyCount: propertyCountFiltering
          }
        })
        return subsections
      } else {
        return []
      }
    },

    // active living option with subsection filtering
    subsectionsWithFiltering: (state, getters) => {
      if (getters.activeLivingOption) {
        // let subsections = []

        getters.activeLivingOption.subsections.forEach(subsection => {
          subsection.filter = false

          if (!subsection.ignoreSidebarFiltering) {
            if (state.inputBeds || state.inputBeds === 0) {
              if (!subsection.filtering.beds.includes(state.inputBeds)) {
                subsection.filter = true
              }
            }

            if (state.inputType) {
              if (!subsection.filtering.homeType.includes(state.inputType)) {
                subsection.filter = true
              }
            }

            if (state.inputView) {
              if (!subsection.filtering.view.includes(state.inputView)) {
                subsection.filter = true
              }
            }

            if (subsection.filtering.propertyCount === 0) {
              subsection.filter = true
            }
          }
        })

        return getters.activeLivingOption.subsections
      } else {
        return []
      }
    },

    subSubsectionsWithFiltering: (state, getters) => {
      if (getters.activeSubsection && getters.activeSubsection.subsections) {
        
        getters.activeSubsection.subsections.forEach(subsection => {
          subsection.filter = false

          if (state.inputBeds || state.inputBeds === 0) {
            if (!subsection.filtering.beds.includes(state.inputBeds)) {
              subsection.filter = true
            }
          }

          if (state.inputType) {
            if (!subsection.filtering.homeType.includes(state.inputType)) {
              subsection.filter = true
            }
          }

          if (state.inputView) {
            if (!subsection.filtering.view.includes(state.inputView)) {
              subsection.filter = true
            }
          }

          if (subsection.filtering.propertyCount === 0) {
            subsection.filter = true
          }
        })

        return getters.activeSubsection.subsections
      } else {
        return []
      }
    },
  }
}
